import { useAddOnQuery } from "features/Reporting/Content/queries/useAddOnQuery";
import { useMemo } from "react";

export type AddOnMatchMode = "or" | "and";

const useHasAddOns = (accountId: number, addOnIds: number[], mode: AddOnMatchMode = "or") => {
  const { data: addons } = useAddOnQuery(accountId);

  return useMemo(() => {
    if (!addOnIds?.length) {
      return false;
    }

    const isAddOnEnabled = (addOnId: number) => !!addons?.find((addon) => addon.id === addOnId)?.isEnabled;

    if (mode === "and") {
      return addOnIds.every((addOnId) => isAddOnEnabled(addOnId));
    }

    return addOnIds.some((addOnId) => isAddOnEnabled(addOnId));
  }, [addons, addOnIds, mode]);
};

export default useHasAddOns;
